import React from 'react';

import { ROUTES } from '@navigation';
import { useNavigationStep } from '@store';

interface LateralMenuHelperOutput {
	isIntroRoute: boolean;
}

export const useLateralMenuHelper = (): LateralMenuHelperOutput => {
	const { intro } = ROUTES;
	const { current: currentRoute } = useNavigationStep();

	const isIntroRoute: boolean = React.useMemo(() => {
		return currentRoute === intro;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentRoute]);

	return { isIntroRoute };
};
